import {ListViewProvider} from './core/ListViewProvider'
import {KTCard, KTSVG} from '../../../../../_metronic/helpers'
import { useEffect, useState } from 'react'
import { downloadCsv, search } from '../../../../../utils/ajax'
import { remoteRoutes } from '../../../../../data/constants'
import toast from 'react-hot-toast'
import { overrideToastDefaults, toastMessages } from '../../../../../data/toastDefaults'
import { printMonthYear, printYearMonthDay } from '../../../../../utils/dateHelpers'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css"
import { triggerFileDownload } from '../../../../../utils/streamlineSpecificHelpers'
import { PersonsTable } from './table/PersonKycTable'

const KycDataList = () => {
  const [verifications, setVerifications] = useState([])
  const [isExporting, setIsExporting]:any = useState(false)
  const [loading, setLoading]:any = useState(false)

  const toDay = new Date(), y = toDay.getFullYear(), m = toDay.getMonth();
  const firstDay = new Date(y, m, 1);
  const lastDay = new Date(y, m + 1, 0);

  const [startDate, setStartDate] = useState(firstDay);
  const [endDate, setEndDate] = useState(lastDay);

  const [from, setFrom]:any = useState(printYearMonthDay(firstDay))
  const [to, setTo]:any = useState(printYearMonthDay(lastDay))
  const [dates, setDates]:any = useState([])

  const updateFilter= (dates:any) => {
    const [start,end]: any = dates
    setFrom(printYearMonthDay(start))
    setTo(printYearMonthDay(end))
    setDates(dates)
  }

  const fetchVerifications = () => {
      setLoading(true)
      search(`${remoteRoutes.statistics}companies?performedon=gte.${from}&performedon=lte.${to}`, {},
          (response) => {
            setVerifications(response)
              if (response.length > 0) {
                  toast.success(toastMessages.default.success, {
                      id: 'fetchAll',
                      ...overrideToastDefaults
                    });
              }
          },
          () => {
              toast.error(toastMessages.default.fail, overrideToastDefaults);
              setLoading(false);
          },
          () => {
              setLoading(false)
          }
      );
  }

  const handleExportCounts = () => {
    setIsExporting(true)
    downloadCsv(`${remoteRoutes.statistics}companies?performedon=gte.${from}&performedon=lte.${to}`, {},
      (rawFile) => {
        triggerFileDownload(rawFile, `STREAMLINE KYB Data of ${printMonthYear(from)}.csv`)
        setIsExporting(false)
          toast.success(toastMessages.exportTotals.success, {
            id: 'fetchAll',
            ...overrideToastDefaults
          });
      },
      () => {
        toast.error(toastMessages.default.fail, overrideToastDefaults);
        setIsExporting(false)
      },
      () => {
        setIsExporting(false)
      }
    );
  }

  useEffect(() => {
    fetchVerifications()
  }, [dates]);

  const onChange = (firstDay:any) => {
    const toDay = firstDay, y = toDay.getFullYear(), m = toDay.getMonth();
    const lastDay = new Date(y, m + 1, 0);
    setStartDate(firstDay);
    setEndDate(lastDay);

    if(firstDay) { updateFilter([firstDay, lastDay]) };
  };

  return (
    <>
      <div className='row mb-6'>
        <div className="col-6">
          <h3 className="card-label fw-bolder mb-0 fs-3">Processed Verification Requests</h3>
          <span className='text-gray-600 fw-bold fs-7'>Select a custom date range & type to filter verification requests</span>
        </div>
        <div className='col-6'>
          <div className='d-flex justify-content-end'>
            <DatePicker
                name="dateFilter"
                id='date-filter'
                className='btn btn-md btn-dark w-200px'
                showMonthYearPicker
                selected={startDate}
                onChange={onChange}
                dateFormat="MMMM yyyy"
            />
            {(!isExporting) && (
              <button className='btn btn-md btn-labo-primary ms-6' onClick={handleExportCounts}>
                <KTSVG path='/assets/media/icons/duotune/arrows/arr091.svg' className='svg-icon-3 text-dark' />
                Export Raw Data
              </button>
            )}
            {(isExporting) && (
              <button type='submit' className='btn btn-md btn-dark ms-6' disabled>
                  <span className=''>
                    Exporting Raw Data...{' '}
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
              </button>
            )}
          </div>
        </div>
      </div>
      <KTCard>
        <PersonsTable data={verifications} loading={loading} />
      </KTCard>
    </>
  )
}

const KycDataListWrapper = () => (
  <ListViewProvider>
    <KycDataList />
  </ListViewProvider>
)

export {KycDataListWrapper}